import { createContext, useContext } from 'react';

interface DrawerContextValue {
  /** Закрыть текущий drawer изнутри */
  close: () => void;
}

export const DrawerContext = createContext<DrawerContextValue | null>(null);

/**
 * useCloseDrawer — хук для закрытия drawer изнутри его контента.
 * Работает только внутри компонента, отрендеренного через useDrawer().
 */
export function useCloseDrawer(): DrawerContextValue {
  const ctx = useContext(DrawerContext);
  if (!ctx) {
    throw new Error(
      'useCloseDrawer() вызван вне контекста drawer. Используйте только внутри компонентов, открытых через useDrawer().'
    );
  }
  return ctx;
}
